// extracted by mini-css-extract-plugin
export var col = "SplitContainer-module--col--e72d9";
export var container = "SplitContainer-module--container--e40f7";